import React, { useState,useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate  } from "react-router-dom";
import { getUrlParameter } from '../infrastructure/apputilityfunctions';
import * as securityActions from '../actions/securityactions';
import securityService from "../services/securityservice"; 

export default function SsoRedirectHandler() {
    const navigate=useNavigate();
    const dispatch = useDispatch();  
    
    let pageMenuId=getUrlParameter('pageId');
    let authToken=getUrlParameter('authToken');

    securityService.setAuthCookie(authToken);
    useEffect(() => {
        console.log("SSO SsoRedirectHandler ");
        dispatch(securityActions.handlessoRedirect(pageMenuId,authToken)).then(resp=>{
            if(resp!=null) {
                navigate(resp);
            }                     
        });
    }, []);

   


}